import {
    escapePrintViewText,
    replaceMediaLikeTagsWithIds,
} from '@/common/questionPrintView/shared'

const buildDrawingQuestionPrintView = (content) => {
    const questionHtml = replaceMediaLikeTagsWithIds(content.question || '')
    const suggestedAnswerHtml = replaceMediaLikeTagsWithIds(content.suggested_answer || '')
    const backgroundImageMediaId = escapePrintViewText(
        content.image && content.image.related_media_id ? content.image.related_media_id : ''
    )
    const backgroundImageHtml = backgroundImageMediaId
        ? `<p>background image media id: ${backgroundImageMediaId}</p>`
        : ''
    const questionSectionHtml = questionHtml ? `<p>Question:</p>${questionHtml}` : ''
    const suggestedAnswerSectionHtml = suggestedAnswerHtml
        ? `<p>Suggested Answer:</p>${suggestedAnswerHtml}`
        : ''

    return `${questionSectionHtml}${suggestedAnswerSectionHtml}${backgroundImageHtml}`
}

export {buildDrawingQuestionPrintView}
